import { useMemo } from 'react';
import { Optional } from 'ts-toolbelt/out/Object/Optional';
import { InboxLocationPhones } from '@frontend/inbox-location-phones';
import { type LocationPhoneSelection, useThreadHeaderContext } from '@frontend/thread-header-context';
import { LocationPhoneSelector, LocationPhoneSelectorProps } from './location-phone-selector';

type Props = Optional<
  Omit<
    LocationPhoneSelectorProps,
    'selectedPersonPhone' | 'selectedLocationPhone' | 'onSelectLocationPhone' | 'variant'
  >,
  'color' | 'hideCurrentLocationPhone'
>;

export const LocationPhoneSelectorAtom = (props: Props) => {
  const {
    groupId,
    personPhone,
    contextPersonId,
    primaryContactId,
    locationPhone: contextLocationPhone,
    onLocationPhoneChange,
    variant,
  } = useThreadHeaderContext();
  const {
    data: { locationPhonesByLocation },
  } = InboxLocationPhones.Hooks.useLocationPhones({ locationIds: [groupId] });
  const locationPhone = useMemo<LocationPhoneSelection | undefined>(() => {
    if (contextLocationPhone) return contextLocationPhone;

    const locationPhones = locationPhonesByLocation[groupId];
    if (locationPhones?.length === 1) {
      return locationPhones[0];
    }

    return undefined;
  }, [contextLocationPhone, groupId, locationPhonesByLocation]);

  if (!locationPhone || !onLocationPhoneChange) {
    return null;
  }

  return (
    <LocationPhoneSelector
      selectedPersonPhone={{ personPhone, personId: contextPersonId || primaryContactId }}
      selectedLocationPhone={locationPhone}
      onSelectLocationPhone={onLocationPhoneChange}
      variant={variant}
      color='default'
      hideCurrentLocationPhone={false}
      {...props}
    />
  );
};
